module.exports = __webpack_public_path__ + "static/media/api.5f998855.svg";